import { TranslateService } from '@ngx-translate/core';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, ElementRef, OnDestroy, OnInit, viewChild } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { ActivatedRoute, Router } from '@angular/router';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { isPanicActive, sleep, venueAcceptsOrders } from '../../../smoothr-web-app-core/utils/utils';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { NavigationService } from 'src/app/services/navigation.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { SelectLanguagePopoverComponent } from 'src/app/components/select-language-popover/select-language-popover.component';
import { MapsUtils } from 'src/smoothr-web-app-core/utils/maps-utils';
import Order from 'src/smoothr-web-app-core/models/Order';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';
import { Swiper, SwiperOptions } from 'swiper/types';
import { SignInModalComponent } from 'src/app/components/sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from 'src/app/components/sign-up-modal/sign-up-modal.component';
import { Subject } from 'rxjs';
import { AppRestorePasswordModalComponent } from '../../components/app-restore-password-modal/app-restore-password-modal.component';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { FacebookPixelEvent } from '../../../smoothr-web-app-core/enums/facebook-pixel-event';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MenuPage } from '../menu/menu.page';
import Address from 'src/smoothr-web-app-core/models/Address';
import { BeforeCreateOrderSelectTimeDialogComponent } from 'src/app/components/before-create-order-select-time-dialog/before-create-order-select-time-dialog.component';
import moment from 'moment';
import { VenueClosedModalComponent } from 'src/app/components/venue-closed-modal/venue-closed-modal.component';
import { PanicModeModalComponent } from 'src/app/components/panic-mode-modal/panic-mode-modalcomponent';

enum Language {
	GreatBritain = 'en',
	German = 'de',
}

@Component({
	selector: 'app-home',
	templateUrl: './home.page.wyniger.html',
	styleUrls: ['./home.page.wyniger.scss'],
})
export class HomePage extends RepositoryDirective implements OnInit, AfterViewInit, OnDestroy {
	static url = 'home';
	static scanUrl = 'scan/:short_id/:table_number';
	environment = environment;
	languageEnum = Language;
	orders: Order[] = [];
	selectedPreorderType: PreorderType = null;
	loading = false;
	opened = false;
	selectedLanguage = Language.German;

	// public contentCards$ = this.brazeService.contentCards$;

	swiper?: Swiper;
	swiperRef = viewChild<ElementRef>('swiperRef');

	flashcards: { prompt: string; id: number }[] = [];
	destroy$ = new Subject();

	constructor(
		protected repository: RepositoryService,
		private router: Router,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController,
		private popover: PopoverController,
		private navService: NavigationService,
		private analyticsService: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private destroyRef: DestroyRef,
		private snackBar: MatSnackBar
	) {
		super(repository);
	}

	ngOnInit() {
		super.ngOnInit();
		this.loading = true;

		this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
			console.log(params, params.get('table_number'));
			if (params && params.get('table_number') && params.get('short_id')) {
				if (params.get('table_number') !== 'take_away') {
					this.loadVenueByQrCode(params.get('table_number'), params.get('short_id'));
				}
			}
		});
	}

	ngAfterViewInit() {
		// this.loadOrders();
	}

	ngOnDestroy(): void {
		this.destroy$.next(null);
		this.destroy$.complete();
	}

	ionViewDidEnter() {
		if (history.state.navigationId === 1) {
			this.repository.onOrderChange(null);
		}
		this.repository.verifiedOrder.emit(null);
	}

	async navigateToMap() {
		this.destroy$.next(true);
		this.navigationService.map();
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.OrderNow);
	}
	async checkGeolocation() {
		try {
			const address = await MapsUtils.getUserGeocode();
			this.repository.address.emit(address);
		} catch (e) {
			console.error(e);
			this.repository.address.emit(null);
		}
	}
	async goToMenu(type: PreorderType) {}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}

	async openPopoverLanuage(ev: any) {
		this.opened = true;
		const popover = await this.popover.create({
			component: SelectLanguagePopoverComponent,
			cssClass: 'popover-home',
			event: ev,
			translucent: true,
			showBackdrop: false,
			side: 'top',
			alignment: 'end',
			reference: 'event',
			componentProps: {
				lang: this.translate.currentLang,
			},
		});
		popover.onWillDismiss().then(v => {
			console.log(v);
			if (v.data) {
				this.translate.setDefaultLang(v.data);
				this.translate.use(v.data);
				this.selectedLanguage = v.data;
			}

			this.opened = false;
		});
		await popover.present();

		return;
	}

	selectedImage() {
		return '../../../assets/' + this.selectedLanguage + '.svg';
	}
	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}

	async selectVenue(venue: Venue, preorderType: PreorderType, attempt: number = 0, prevError: any = null) {
		if (!venueAcceptsOrders(venue, preorderType)) {
			return;
		}

		try {
			await this.repository.getVenue(venue._id);
			this.repository.createOrder(venue, this.address, OrderType.PREORDER, preorderType);

			await sleep(1000);
			this.navService.foodSpot();

			this.loading = false;
		} catch (e) {
			await this.selectVenue(venue, preorderType, attempt + 1, e);
		}
	}

	async openAuth() {
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.SignInOrJoin);
		const result = await SignInModalComponent.show(this.modalCtrl);
		await this.modalCtrl.dismiss().catch(e => {});
		if (result === 'sign-up') {
			await SignUpModalComponent.show(this.modalCtrl);
		}
		if (result === 'forgot-password') {
			await AppRestorePasswordModalComponent.show(this.modalCtrl);
		}
	}

	async loadVenueByQrCode(tableNumber: string, venueId: string) {
		this.loading = true;
		try {
			const venueData = (await Api.getLazyVenue(venueId, true)).data;

			if (isPanicActive(venueData)) {
				PanicModeModalComponent.show(this.modalCtrl);
				this.loading = false;

				return;
			}

			const table = (await Api.getTable(venueData._id, tableNumber)).data as any;
			const isVenueOpen =
				venueData &&
				venueData.isServiceActivated &&
				(venueData.openingHours.length == 0 || TimeUtils.doesHoursMatch(moment(), venueData.openingHours));
			// console.log({
			// 	openingHours: venueData.openingHours,
			// 	doesHoursMatchNow: TimeUtils.doesHoursMatch(moment(), venueData.openingHours, "OPENING")
			// })
			if (!isVenueOpen) {
				this.loading = false;
				VenueClosedModalComponent.show(
					this.modalCtrl,
					this.translate.instant('home_page.venue_closed.title')
					// this.translate.instant('home_page.venue_closed.text')
				);
				return;
			}

			await sleep(100);

			if (venueData && table) {
				if (!table?.active) {
					this.loading = false;

					await VenueClosedModalComponent.show(
						this.modalCtrl,
						this.translate.instant('home_page.scan_table_error.title'),
						this.translate.instant('home_page.scan_table_error.text')
					);

					return;
				}
				this.repository.venue.emit(venueData);
				this.repository.createOrder(this.venue, null, OrderType.PREORDER, PreorderType.INSIDE);
				this.order.tableNumber = table.number;
				this.order.table = table._id;
				this.repository.onOrderChange(this.order);
				sleep(200);
				await MenuPage.navigate(this.router);
			}
			this.loading = false;
		} catch (e) {
			this.snackBar.open(this.translate.instant('home_page.scan_table_error'), null, {
				duration: 2000,
			});
			this.loading = false;
		}
	}

	async getVenueAndRedirecttoMenu() {
		const wynigerVenue = await this.repository.getAllVenues(environment.customerGroup);
		const publishedVenues = wynigerVenue.filter(venue => venue.isPublished === true);
		const candidateVenue = publishedVenues[0];

		if (isPanicActive(candidateVenue)) {
			PanicModeModalComponent.show(this.modalCtrl);
			this.loading = false;

			return;
		}

		await this.loadVenueAndCreateOrder(candidateVenue, this.address);
		sleep(200);
		await MenuPage.navigate(this.router);
	}

	async loadVenueAndCreateOrder(venue: Venue, address: Address) {
		this.repository.createOrder(venue, address, OrderType.PREORDER, PreorderType.TAKE_AWAY);
	}
}
